import { useTranslation } from 'react-i18next';

import { type ListItemState } from '../../../../../components/ListWithContentLayout/types';
import Card from '../../../../../components/ListWithContentLayout/components/Card/Card';
import { ArrayFields, ItemsTabFields } from '../../../../License/types/fieldEnums';
import { type IItemResponse } from '../../../../License/types/response';

import useComparisonValues from '../../../hooks/useComparisonValues';

interface IItemComparisonCardProps extends IItemResponse {
  onClick: () => void;
  isActive: boolean;
  itemState?: ListItemState;
  index: number;
  searchText: string;
}

function ItemComparisonCard({
  onClick,
  isActive,
  itemState,
  index,
  searchText,
  id,
  ...rest
}: IItemComparisonCardProps) {
  const { t } = useTranslation();

  const { newValue: commodityCode } = useComparisonValues({
    path: `/${ArrayFields.items}/${id}/${ItemsTabFields.commodityCode}`,
    value: rest.commodityCode,
  });

  const { newValue: commodityDescription } = useComparisonValues({
    path: `/${ArrayFields.items}/${id}/${ItemsTabFields.commodityDescription}`,
    value: rest.commodityDescription,
  });

  const { newValue: countryOfOriginCode } = useComparisonValues({
    path: `/${ArrayFields.items}/${id}/${ItemsTabFields.countryOfOriginCode}`,
    value: rest.countryOfOriginCode,
  });

  const { newValue: commercialDescription } = useComparisonValues({
    path: `/${ArrayFields.items}/${id}/${ItemsTabFields.commercialDescription}`,
    value: rest.commercialDescription,
  });

  const { newValue: manufacturerName } = useComparisonValues({
    path: `/${ArrayFields.items}/${id}/${ItemsTabFields.manufacturerName}`,
    value: rest.manufacturerName,
  });

  if (
    !searchText ||
    (commercialDescription as string)?.toLowerCase().includes(searchText) ||
    (commodityCode as string)?.startsWith(searchText) ||
    (commodityDescription as string)?.toLowerCase().includes(searchText) ||
    (manufacturerName as string)?.toLowerCase().includes(searchText)
  ) {
    return (
      <Card
        statusText={commodityCode as string}
        itemState={itemState}
        isActive={isActive}
        title={index + 1}
        onClick={onClick}
      >
        <div>
          <span>{t('Country of Origin')}:</span>
          <span className="typography-dark">{(countryOfOriginCode as string) || '-'}</span>
        </div>
        <div className="two-line-ellipsis">{commercialDescription as string}</div>
      </Card>
    );
  }

  return null;
}

export default ItemComparisonCard;
